import type {
  IPlayerNotification,
  PlayerNotificationAction,
} from "src/types/notification";

type ActionSource = Pick<
  IPlayerNotification,
  "type" | "action_url1" | "action_url2"
>;

function positiveInteger(value: string | null): string | null {
  if (!value || !/^[1-9]\d*$/.test(value)) return null;

  const parsed = Number(value);
  return Number.isSafeInteger(parsed) ? value : null;
}

function internalPath(value: string | null): string | null {
  const path = value?.trim();

  if (
    !path ||
    !path.startsWith("/") ||
    path.startsWith("//") ||
    path.includes("\\") ||
    /[\u0000-\u001f\u007f]/.test(path)
  ) {
    return null;
  }

  return path;
}

export function resolvePlayerNotificationAction(
  notification: ActionSource,
): PlayerNotificationAction | null {
  if (notification.type === "message") {
    const conversationId = positiveInteger(notification.action_url1);
    return conversationId
      ? { href: `/player/messages?id=${conversationId}` }
      : null;
  }

  if (notification.type === "team_invitation") {
    return { href: "/invitations?type=team" };
  }

  if (notification.type.startsWith("inactivity_recovery_")) {
    const href = internalPath(notification.action_url1);
    return href ? { href } : null;
  }

  if (notification.type.startsWith("provider_post_notif_")) {
    const postId = positiveInteger(notification.action_url1);
    return postId ? { href: `/post/${postId}` } : null;
  }

  if (notification.type === "systemmessage" || ["championship_result_reminder", "championship_result_escalation"].includes(notification.type)) {
    const href = internalPath(notification.action_url1);
    return href ? { href } : null;
  }

  return null;
}
